import React, { FC, RefObject } from 'react'
import { Direction, REQUEST_CONFIGS_KEYS } from '@services/constants'
import TextInput from '../inputs/text.inputs'
import RadioInput from '../inputs/radio.input'
import { CheckboxList, RadioList, SelectList } from '@utils/request'
import * as utilsList from './__index.utils'
import Notification from '@components/ui/notification'
import CheckboxInput from '../inputs/checkbox.input'
import SelectInput from '../inputs/select.inputs'
import MeasurementInput from '../inputs/measurement.input'
import { joinClasses } from '@utils/styles'
import TextAreaInput from '../inputs/textarea.inputs'
import MaskedTextInput from '../inputs/textWithValidation.inputs'
import DateFilterInput from '../inputs/datefilter.input'

const Step4_3HomeOfficeOrBusiness = ({
	pageAssets,
	pageUtils,
	formInputs,
	errors,
	updateInput,
	onFixError,
	isSummaryStep = false,
	// *******
	updateCheckBoxInput
}) => {
	const {
		whatToDo,

		// ***********************
		typesOfWorkOccupation,
		

		typesOfWorkHomeOffice,
		typesOfWorkHomeOfficeDetails,
		occupantNameHomeOffice,
		occupiedAreaHomeOffice,
		occupiedAreaUnitHomeOffice,
		occupationActivityDescriptionHomeOffice,
		startDateHomeOffice,
		endDateHomeOffice,
		isSignInstallationPlanned
	} = formInputs

	const radioListTypesOfWorkHomeOffice: RadioList[] =
		utilsList.radioListHomeOfficeOrBusinessType(pageAssets)

	const radioListMeasurement2Unit: RadioList[] =
		utilsList.radioListMeasurement2Unit(pageAssets)

	const radioListYesNo: RadioList[] = utilsList.radioListYesNo(pageAssets)

	const getLabelFromList = (list, value) => {
		return list?.find((element) => element.value == value?.toString())?.label
	}

	
	return (
		<>
			{!isSummaryStep && (
				<h4 className={pageUtils.classes.h4}>
					{pageAssets?.request_form_occupation_informations}
				</h4>
			)}

			<RadioInput
				name={typesOfWorkHomeOffice.name}
				label={typesOfWorkHomeOffice.label}
				value={typesOfWorkHomeOffice.value}
				list={radioListTypesOfWorkHomeOffice}
				direction={Direction.vertical}
				hasError={errors!.includes(typesOfWorkHomeOffice.name)}
				onChange={(value) => updateInput(typesOfWorkHomeOffice.name, value)}
				ref={typesOfWorkHomeOffice.ref as RefObject<HTMLInputElement>}
				required={typesOfWorkHomeOffice.required}
				hasBackgroundWrapper={true}
				isSummaryStep={isSummaryStep}
			/>

			{typesOfWorkHomeOffice.value ==
				REQUEST_CONFIGS_KEYS.homeOfficeOrBusinessType.others && (
				<TextInput
					id={typesOfWorkHomeOfficeDetails.name}
					label={typesOfWorkHomeOfficeDetails.label}
					value={typesOfWorkHomeOfficeDetails.value}
					onChange={(value) =>
						updateInput(typesOfWorkHomeOfficeDetails.name, value)
					}
					hasError={errors!.includes(typesOfWorkHomeOfficeDetails.name)}
					required={typesOfWorkHomeOfficeDetails.required}
					ref={typesOfWorkHomeOfficeDetails.ref as RefObject<HTMLInputElement>}
					maxCharacters={100}
					isSummaryStep={isSummaryStep}
				/>
			)}

			<TextInput
				id={occupantNameHomeOffice.name}
				label={occupantNameHomeOffice.label}
				value={occupantNameHomeOffice.value}
				onChange={(value) => updateInput(occupantNameHomeOffice.name, value)}
				hasError={errors!.includes(occupantNameHomeOffice.name)}
				required={occupantNameHomeOffice.required}
				ref={occupantNameHomeOffice.ref as RefObject<HTMLInputElement>}
				maxCharacters={50}
				isSummaryStep={isSummaryStep}
			/>

			<MeasurementInput
				measurementInput={occupiedAreaHomeOffice}
				unitInput={occupiedAreaUnitHomeOffice}
				listMeasurementUnit={radioListMeasurement2Unit}
				maxCharacters={12}
				isSummaryStep={isSummaryStep}
				errors={errors}
				onFixError={onFixError}
				updateInput={updateInput}
				hasError={errors?.includes(occupiedAreaHomeOffice.name)}
				reducedMargin
			/>

			<TextAreaInput
				id={occupationActivityDescriptionHomeOffice.name}
				label={occupationActivityDescriptionHomeOffice.label}
				value={occupationActivityDescriptionHomeOffice.value}
				onChange={(value) =>
					updateInput(occupationActivityDescriptionHomeOffice.name, value)
				}
				hasError={errors!.includes(
					occupationActivityDescriptionHomeOffice.name
				)}
				required={occupationActivityDescriptionHomeOffice.required}
				ref={
					occupationActivityDescriptionHomeOffice.ref as RefObject<HTMLTextAreaElement>
				}
				maxCharacters={500}
				hasDescriptionLabel={
					occupationActivityDescriptionHomeOffice.description
				}
				displayDescriptionTop
				descriptionAlignment="left"
				rows={4}
				isSummaryStep={isSummaryStep}
			/>

			{/* // Prévoyez-vous faire l'installation d'une ou des enseigne(s)? */}
			<RadioInput
				name={isSignInstallationPlanned.name}
				label={isSignInstallationPlanned.label}
				value={isSignInstallationPlanned.value}
				list={radioListYesNo}
				direction={Direction.vertical}
				hasError={errors!.includes(isSignInstallationPlanned.name)}
				onChange={(value) =>
					updateInput(isSignInstallationPlanned.name, value)
				}
				ref={isSignInstallationPlanned.ref as RefObject<HTMLInputElement>}
				required={isSignInstallationPlanned.required}
				hasBackgroundWrapper={true}
				isSummaryStep={isSummaryStep}
				reducedMargin={true}
			/>

			{!isSummaryStep &&
				isSignInstallationPlanned.value?.toString() == 'true' && (
					<Notification
						text={
							pageAssets?.request_form_isSignInstallationPlanned_notification_label
						}
						type="info"
						hasHtml
					/>
				)}

			{/* Dates d'occupation */}
			<h5 className={pageUtils.classes.h5}>
				{pageAssets?.request_form_dateOccupation}
			</h5>

			<div className={pageUtils.classes.fieldsContainer}>
				<DateFilterInput
					id={startDateHomeOffice.name}
					label={startDateHomeOffice.label}
					value={startDateHomeOffice.value}
					onChange={(value) => updateInput(startDateHomeOffice.name, value)}
					hasError={errors!.includes(startDateHomeOffice.name)}
					required={startDateHomeOffice.required}
					dateFormat="dd/MM/yyyy"
					minDate={new Date()}
					isSummaryStep={isSummaryStep}
				/>

				<DateFilterInput
					id={endDateHomeOffice.name}
					label={endDateHomeOffice.label}
					value={endDateHomeOffice.value}
					onChange={(value) => updateInput(endDateHomeOffice.name, value)}
					hasError={errors!.includes(endDateHomeOffice.name)}
					required={endDateHomeOffice.required}
					dateFormat="dd/MM/yyyy"
					minDate={new Date(startDateHomeOffice.value + 'T12:00:00')}
					disabled={startDateHomeOffice.value == ''}
					isSummaryStep={isSummaryStep}
				/>
			</div>

		
		</>
	)
}

export default Step4_3HomeOfficeOrBusiness
